import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { OrderService } from '../../../core/services/order.service';
import { BoletaService, BoletaVenta } from '../../../core/services/boleta.service';
import { PeruDatePipe } from '../../pipes/peru-date.pipe';

@Component({
  selector: 'app-mp-payment-panel',
  standalone: true,
  imports: [CommonModule, ButtonModule, TagModule, PeruDatePipe],
  templateUrl: './mp-payment-panel.html',
})
export class MpPaymentPanel implements OnChanges {
  @Input() order: any = null;

  boleta: BoletaVenta | null = null;
  boletaLoading = false;
  downloading = false;
  paymentUrlBase = '';

  private static cachedPaymentUrlBase: string | null = null;

  constructor(private orderService: OrderService, private boletaService: BoletaService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['order']) {
      this.loadPanelConfig();
      this.loadBoleta();
    }
  }

  get paymentUrl(): string | null {
    if (!this.paymentUrlBase || !this.order?.mpPaymentId) return null;
    return this.paymentUrlBase + encodeURIComponent(this.order.mpPaymentId);
  }

  get mpSeverity(): 'success' | 'danger' | 'warn' | 'info' | 'secondary' {
    switch ((this.order?.mpStatus || '').toLowerCase()) {
      case 'approved': return 'success';
      case 'rejected':
      case 'cancelled':
      case 'refunded':
      case 'charged_back': return 'danger';
      case 'expired': return 'warn';
      case 'pending':
      case 'in_process':
      case 'authorized': return 'info';
      default: return 'secondary';
    }
  }

  descargarBoleta(): void {
    if (!this.boleta) return;
    const boleta = this.boleta;
    this.downloading = true;
    this.boletaService.descargarPdf(boleta.id).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${boleta.numeroCompleto || 'boleta'}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.downloading = false;
      },
      error: () => { this.downloading = false; }
    });
  }

  private loadPanelConfig(): void {
    if (MpPaymentPanel.cachedPaymentUrlBase !== null) {
      this.paymentUrlBase = MpPaymentPanel.cachedPaymentUrlBase;
      return;
    }
    this.orderService.getMercadoPagoPanelConfig().subscribe({
      next: (res) => {
        MpPaymentPanel.cachedPaymentUrlBase = res?.paymentUrlBase || '';
        this.paymentUrlBase = MpPaymentPanel.cachedPaymentUrlBase;
      },
      error: () => { this.paymentUrlBase = ''; }
    });
  }

  private loadBoleta(): void {
    this.boleta = null;
    const orderId = this.order?.id;
    if (!orderId) return;
    this.boletaLoading = true;
    this.boletaService.obtenerPorOrden(orderId).subscribe({
      next: (b) => {
        if (this.order?.id === orderId) this.boleta = b;
        this.boletaLoading = false;
      },
      error: () => { this.boletaLoading = false; }
    });
  }
}
